<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { WebSocketEventBus } from '@/modules/websockets/models/WebSocketEventBus';
import { WebSocketAction } from '@/modules/websockets/enums/WebSocketAction';

@Component
export default class AppLayout extends Vue {
  private wsRefreshTimer: ReturnType<typeof setTimeout> | null = null;
  private pollTimer: ReturnType<typeof setInterval> | null = null;
  private readonly POLL_INTERVAL_MS = 60_000;
  private onChatEvent: ((message: any) => void) | null = null;
  private unwatch: (() => void) | null = null;

  public created() {
    this.unwatch = this.$watch(
      () => (this.$store.state as any).auth?.user?.id,
      (id: any) => {
        if (id) {
          this.$store.dispatch('messages/loadRecentChats');
        }
      },
      { immediate: true },
    );

    this.$watch(
      () => (this.$store.state as any).personalAssistants?.currentActingBrokerUser?.id,
      (id: any) => {
        if (id) {
          this.$store.dispatch('messages/loadRecentChats');
        }
      },
    );

    this.onChatEvent = (message: any) => {
      if (message?.chat?.id) {
        if (this.wsRefreshTimer) clearTimeout(this.wsRefreshTimer);
        this.wsRefreshTimer = setTimeout(() => {
          this.wsRefreshTimer = null;
          this.$store.dispatch('messages/loadRecentChats');
        }, 500);
      }
    };

    WebSocketEventBus.$on(WebSocketAction.CHAT_READ_MESSAGE, this.onChatEvent);
    WebSocketEventBus.$on(WebSocketAction.CHAT_SEND_MESSAGE, this.onChatEvent);

    this.pollTimer = setInterval(() => {
      this.$store.dispatch('messages/loadRecentChats');
    }, this.POLL_INTERVAL_MS);
  }

  public beforeDestroy() {
    if (this.unwatch) this.unwatch();
    if (this.wsRefreshTimer) clearTimeout(this.wsRefreshTimer);
    if (this.pollTimer) clearInterval(this.pollTimer);
    if (this.onChatEvent) {
      WebSocketEventBus.$off(WebSocketAction.CHAT_READ_MESSAGE, this.onChatEvent);
      WebSocketEventBus.$off(WebSocketAction.CHAT_SEND_MESSAGE, this.onChatEvent);
    }
  }
}
</script>

<style lang="scss">
@import 'theme/design.scss';

html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: 'Lexend', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $font-base-color;
  background-color: $background-color;
  font-size: $font-size;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: #ebebeb;
  -webkit-border-radius: 10px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: $font-base-color;
}
</style>
